<div class="flex flex-row pb-3 justify-between relative items-center">
    <h2 class="dialog-heading"></h2>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._bottomSheetRef.dismiss()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<div class="p-4">
    <div class="autoScroll">
        <img src="assets/images/ui/saver-info.png" alt="" class="w-44 mb-6 mx-auto">
        <h3 class="text-center text-[26px] leading-7 font-semibold text-blue-theme-color mb-3">Saver Delivery</h3>
        <p class="text-center text-lg leading-[26px] font-medium max-w-80 mx-auto text-blue-theme-color">Delivery will take a little longer, but you’ll pay lower fares.</p>
        <ul class="saver-info-list">
            <li><img src="assets/images/ui/checked.png" alt=""><p>Receive a <span>discount</span> on your order.</p></li>
            <li><img src="assets/images/ui/checked.png" alt=""><p>Perfect for <span>budget-friendly</span> deliveries without the rush.</p></li>
            <li><img src="assets/images/ui/checked.png" alt=""><p>Great for saving on non-urgent deliveries, allowing you to enjoy a <span>lower rate</span>.</p></li> 
        </ul>
    </div>
</div>